module.exports = __webpack_public_path__ + "img/269-info.7ca34c4c.svg";